import { useMemo } from 'react'
import { tokens } from '@/locales/translations/tokens'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { SourceCardList } from '../ask/source-animated-card'

interface SearchResultsProps {
  results: SearchResult[]
  searchGroupId?: string
  messageId: string
}

export const FileToolSearchResultSources = ({
  results,
  messageId,
}: SearchResultsProps) => {
  const { t } = useTranslation()
  const cardsData = useMemo(
    () =>
      results.map((result) => {
        const cardData = {
          id: result.id || `result-${result.score.toFixed(2)}`,
          title: result.attributes.fileName || 'Result',
          category: result.attributes.pageNumber
            ? `${t(tokens.ui.common.page)} ${String(result.attributes.pageNumber)} - ${t(tokens.workstation.sources.relevance)}: ${result.score.toFixed(2)}`
            : `${t(tokens.workstation.sources.relevance)}: ${result.score.toFixed(2)}`,
          pointOfInterest: Math.floor(result.score * 100),
          imageUrl: result.attributes.publicSourceUrl,
          content: result.attributes.markdown || result.attributes.summary,
          attributes: {
            ...result.attributes,
            fileId:
              result.attributes.fileId ||
              result.id ||
              `result-${result.score.toFixed(2)}`,
            pageNumber: result.attributes.pageNumber
              ? String(result.attributes.pageNumber)
              : undefined,
          },
        }

        return cardData
      }),
    [results, t]
  )

  if (!results || results.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className='py-4 text-center text-zinc-500 dark:text-zinc-400'
      >
        {t(tokens.ui.common.noResultsFound)}
      </motion.div>
    )
  }

  return (
    <div className='space-y-3'>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <SourceCardList cards={cardsData} messageId={messageId} />
      </motion.div>
    </div>
  )
}
